export default {
  loadingScheme: 'Schéma zakladania',
  partNoPlaceholder: 'Zadajte číslo dielu',
  noAssetQualificationsMatch: 'Diel "{part}" nie je možné spracovať v peci "{asset}".',
  noMatchedRecipeFound: 'Diel "{part}" nie je možné spracovať v peci "{asset}" s receptúrou "{recipe}".',
  amountDoesNotMatch: 'Bol prekročený maximálny počet dielov "{part}". Je povolené založiť "{max}" dielov, ale bolo založených "{actual}".',
  totalWeight: 'Celková hmotnosť',
};
